// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.alert-loader img {
  height: 30px;
  width: 30px;
}

.notifications-container ul {
  padding-left: 25px;
}
.notifications-container ul li {
  padding: 0 !important;
}
.notifications-container .toggle-header i {
  left: 0;
  top: 45%;
}
.notifications-container .toggle-header span {
  margin-left: 30px;
}
.notifications-container .toggle-header .count-circle {
  background-color: hsl(0, 66%, 49%);
  border: 1px solid hsl(0, 66%, 49%);
  border-radius: 50%;
  box-sizing: content-box;
  color: hsl(0, 0%, 95%);
  display: inline-block;
  font-size: 16px;
  height: 20px;
  margin-left: 10px;
  text-align: center;
  vertical-align: text-top;
  min-width: 20px;
}
.notifications-container .toggle-header.active .count-circle {
  background-color: hsl(0, 0%, 35%);
}
.notifications-container .toggle-header.active .accheader {
  color: hsl(0, 0%, 35%);
}
@media (max-width: 1024px) {
  .notifications-container .toggle-header .count-circle {
    font-size: 14px;
  }
}
.notifications-container li {
  color: hsl(0, 66%, 49%);
  font-size: 30px;
  line-height: 20px;
  list-style-position: outside;
  list-style-type: disc;
  margin-right: 10px;
}
.notifications-container li .alert-list {
  padding: 10px 0;
}
.notifications-container li .horizontal-separator {
  border-bottom: 1px solid #d2d2d2;
  margin-left: -20px;
}
.notifications-container .notification-header {
  color: #191919;
  display: inline-block;
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 14px;
  vertical-align: top;
  width: 91%;
}
.notifications-container .dismiss-alert {
  background-color: hsl(204.9, 94.4%, 35.1%);
  border-radius: 50%;
  float: right;
  height: 20px;
  text-align: center;
  width: 20px;
}
.notifications-container .dismiss-alert i {
  color: hsl(0, 0%, 95%);
  font-size: 14px;
  margin: -1px 0 0;
}
.notifications-container .notification-description {
  color: #191919;
  font-family: "Omnes-ATT-W02";
  font-size: 14px;
  padding: 10px 0;
}
.notifications-container .notification-description .action-links {
  display: inline-block;
  font-size: 14px;
  padding-top: 10px;
}
.notifications-container .notification-description .action-links a {
  border: 0;
  display: inline;
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 14px;
  margin: 0;
  padding: 0;
}
.notifications-container .notification-description .action-links a:focus {
  outline: 1px dotted #191919;
}
.notifications-container .notification-description .action-links .line-separator {
  border-left: 1px solid #d2d2d2;
  margin: 5px;
}
.notifications-container .notification-description .disable-cursor a {
  color: #c4c4c4;
}
.notifications-container .more-alerts {
  color: hsl(204.9, 94.4%, 35.1%);
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 16px;
}
.notifications-container .more-alerts a {
  border: 0;
  padding: 0;
}
.notifications-container .more-alerts a:focus {
  outline: 1px dotted #191919;
}
.notifications-container .accordion .disabled {
  color: #c4c4c4;
}
.notifications-container .accordion .disabled i {
  color: #c4c4c4;
}
.notifications-container .accordion .disabled .count-circle {
  background-color: #767676;
  border-color: #767676;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/notifications/notifications.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJE;EACE,YAAA;EACA,WAAA;AAkJJ;;AA7IE;EACE,kBAAA;AAgJJ;AA9II;EACE,qBAAA;AAgJN;AA1II;EACE,OAAA;EACA,QAAA;AA4IN;AAzII;EACE,iBAAA;AA2IN;AAxII;EACE,kCAAA;EACA,kCAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;AA0IN;AArIM;EACE,iCAAA;AAuIR;AArIM;EACE,sBAAA;AAuIR;AFjKI;EEiCE;IACE,eAAA;EAmIN;AACF;AA/HE;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;AAiIJ;AA/HI;EACE,eAAA;AAiIN;AA9HI;EACE,gCAAA;EACA,kBAAA;AAgIN;AA5HE;EACE,cAAA;EACA,qBAAA;EACA,mCAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AA8HJ;AA3HE;EACE,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AA6HJ;AA3HI;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AA6HN;AAzHE;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,eAAA;AA2HJ;AAzHI;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;AA2HN;AAzHM;EACE,SAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AA2HR;AA1HQ;EACE,2BAAA;AA4HV;AAxHM;EACE,8BAAA;EACA,WAAA;AA0HR;AArHM;EACE,cAAA;AAuHR;AAlHE;EACE,+BAAA;EACA,mCAAA;EACA,eAAA;AAoHJ;AAlHI;EACE,SAAA;EACA,UAAA;AAoHN;AAnHM;EACE,2BAAA;AAqHR;AA9GI;EACE,cAAA;AAgHN;AA9GM;EACE,cAAA;AAgHR;AA7GM;EACE,yBAAA;EACA,qBAAA;AA+GR","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.alert-loader {\n  img {\n    height: 30px;\n    width: 30px;\n  }\n}\n\n.notifications-container {\n  ul {\n    padding-left: 25px;\n\n    li {\n      padding: 0 !important;\n    }\n  }\n\n  .toggle-header {\n\n    i {\n      left: 0;\n      top: 45%;\n    }\n     \n    span {\n      margin-left: 30px;\n    }\n\n    .count-circle {\n      background-color: color(danger, base);\n      border: 1px solid color(danger, base);\n      border-radius: 50%;\n      box-sizing: content-box;\n      color: color(default, base);\n      display: inline-block;\n      font-size: 16px;\n      height: 20px;\n      margin-left: 10px;\n      text-align: center;\n      vertical-align: text-top;\n      min-width: 20px;\n    }\n\n    \n    &.active{\n      .count-circle{\n        background-color: color(inverse, base);\n      }\n      .accheader{\n        color : color(inverse, base);\n        \n      }\n      \n    }\n\n    @include respond-to(small) {\n      .count-circle {\n        font-size: 14px;\n      }\n    }\n  }\n\n  li {\n    color: color(danger, base);\n    font-size: 30px;\n    line-height: 20px;\n    list-style-position: outside;\n    list-style-type: disc;\n    margin-right: 10px;\n\n    .alert-list {\n      padding: 10px 0;\n    }\n\n    .horizontal-separator {\n      border-bottom: 1px solid color(default, dark);\n      margin-left: -20px;\n    }\n  }\n\n  .notification-header {\n    color: color(inverse, darker);\n    display: inline-block;\n    font-family: 'Omnes-ATT-W02-Medium';\n    font-size: 14px;\n    vertical-align: top;\n    width: 91%;\n  }\n\n  .dismiss-alert {\n    background-color: color(secondary, base);\n    border-radius: 50%;\n    float: right;\n    height: 20px;\n    text-align: center;\n    width: 20px;\n\n    i {\n      color: color(default, base);\n      font-size: 14px;\n      margin: -1px 0 0;\n    }\n  }\n\n  .notification-description {\n    color: color(inverse, darker);\n    font-family: 'Omnes-ATT-W02';\n    font-size: 14px;\n    padding: 10px 0;\n\n    .action-links {\n      display: inline-block;\n      font-size: 14px;\n      padding-top: 10px;\n\n      a {\n        border: 0;\n        display: inline;\n        font-family: 'Omnes-ATT-W02-Medium';\n        font-size: 14px;\n        margin: 0;\n        padding: 0;\n        &:focus {\n          outline: 1px dotted color(inverse, darker);\n        }\n      }\n\n      .line-separator {\n        border-left: 1px solid color(default, dark);\n        margin: 5px;\n      }\n    }\n\n    .disable-cursor {\n      a {\n        color: color(default, darker);\n      }\n    }\n  }\n\n  .more-alerts {\n    color: color(secondary, base);\n    font-family: 'Omnes-ATT-W02-Medium';\n    font-size: 16px;\n\n    a {\n      border: 0;\n      padding: 0;\n      &:focus {\n        outline: 1px dotted color(inverse, darker);\n      }\n    }\n  }\n  \n  .accordion {\n\n    .disabled {\n      color: color(default, darker);\n\n      i {\n        color: color(default, darker);\n      }\n  \n      .count-circle {\n        background-color: color(inverse, light);\n        border-color: color(inverse, light);\n      }\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
